const SampleDropDown = () => {
    const showButton = document.getElementById('showDropdown');
    const content = document.getElementById('dropdown');

    if(showButton) {
      showButton.addEventListener('click', function() {
        content.classList.toggle("hidden");
      });
    }
    

}

export default SampleDropDown